import React from "react";
import PropTypes from "prop-types";

import { makeStyles } from "@material-ui/core/styles";
// @material-ui/icons
import style from "assets/jss/material-dashboard-pro-react/views/sweetAlertStyle.js";
import SweetAlert from "react-bootstrap-sweetalert";
import { cardTitle } from "assets/jss/material-dashboard-pro-react.js";

const styles = {
  ...style,
  right: {
    float: "right"
  },
  left: {
    float: "left"
  },
  center: { margin: " 0 auto" },
  cardIconTitle: {
    ...cardTitle,
    marginTop: "15px",
    marginBottom: "0px"
  }
};

const useStyles = makeStyles(styles);
export default function Alert(props) {
  const { alert, updateAlert } = props;

  const classes = useStyles();
  let confirmBtnCssClass = `${classes.button}  ${classes.success}`;
  if (alert && alert.showCancel) {
    confirmBtnCssClass += " " + classes.left;
  }
  let confirm = () => {
    updateAlert(null);
  };
  if (alert && alert.confirm) {
    confirm = alert.confirm;
  }

  return (
    <>
      {alert ? (
        <SweetAlert
          success={alert.success}
          danger={alert.danger}
          style={{ display: "block", marginTop: "-100px" }}
          title={alert.title}
          onConfirm={confirm}
          onCancel={() => {
            updateAlert(null);
          }}
          cancelBtnCssClass={
            classes.button + " " + classes.danger + " " + classes.right
          }
          confirmBtnCssClass={confirmBtnCssClass}
          confirmBtnText={alert.confirmBtnText}
          cancelBtnText="Chiudi"
          showCancel={alert.showCancel}
          // confirmBtnCssClass={classes.button + " " + classes.success}
        >
          {alert.text}
        </SweetAlert>
      ) : null}
    </>
  );
}

Alert.propTypes = {
  alert: PropTypes.object,
  updateAlert: PropTypes.func
};
